import React, { forwardRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import classNames from 'classnames';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import styles from './DropdownField.module.scss';
import './DropdownField.scss';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

interface DropdownFieldProps {
  id?: string;
  label?: string;
  options?: { name: string; value: string | number }[];
  value?:
    | number
    | string
    | null
    | { name: string; value: string | number }
    | unknown[];
  placeholder?: string;
  onChange?: (e: {
    value: string | null;
    target?: { name: string; value?: unknown };
  }) => void;
  error?: string;
  showClear?: boolean;
  className?: string;
  itemTemplate?: (option: OptionType) => JSX.Element;
  name?: string;
  required?: boolean;
  multiple?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  defaultValue?: string | number | readonly string[];
  tooltip?: string;
  appendTo?: HTMLElement | 'self' | (() => HTMLElement) | null;
}

export interface OptionType {
  name: string;
  value: string;
  icon: IconDefinition;
  color: 'main' | 'danger';
}

const DropdownField = forwardRef<Dropdown, DropdownFieldProps>(
  (
    {
      id,
      label,
      options,
      value,
      placeholder,
      onChange,
      error,
      showClear,
      className,
      itemTemplate,
      name,
      required,
      multiple,
      isLoading,
      disabled,
      defaultValue,
      tooltip,
      appendTo,
    },
    ref
  ) => {
    return (
      <div className={classNames(styles.fieldContainer, className)}>
        {label && (
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
        )}
        <Dropdown
          tooltip={tooltip}
          tooltipOptions={{ position: 'top' }}
          multiple={multiple}
          id={id}
          value={value}
          options={options}
          onChange={onChange}
          optionLabel="name"
          placeholder={placeholder}
          itemTemplate={itemTemplate ?? null}
          className={classNames(
            styles.field,
            error && styles.invalid,
            'dropdownFixedWidth'
          )}
          showClear={showClear}
          name={name}
          required={required}
          filterInputAutoFocus
          autoFocus
          disabled={isLoading || disabled}
          defaultValue={defaultValue}
          appendTo={appendTo}
          ref={ref}
        />
        {error ? <p className={styles.errorMessage}>{error}</p> : null}
        {isLoading && <LoadingSpinner className={styles.spinnerForDropdown} />}
      </div>
    );
  }
);
DropdownField.displayName = 'DropdownField';

export default DropdownField;
